// extracted by mini-css-extract-plugin
module.exports = {"movingTips":"index-module--movingTips--1_lPw","customerReviews":"index-module--customer-reviews--YKEIz","faq":"index-module--faq--32Xon"};